import { render, staticRenderFns } from "./itable.vue?vue&type=template&id=6bd43339&scoped=true&"
var script = {}
import style0 from "./itable.vue?vue&type=style&index=0&id=6bd43339&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd43339",
  null
  
)

export default component.exports